import { render } from "./ClearfilterBtn.vue?vue&type=template&id=ac8c9d44&scoped=true"
const script = {}

import "./ClearfilterBtn.vue?vue&type=style&index=0&id=ac8c9d44&scoped=true&lang=css"

import exportComponent from "D:\\xampp\\htdocs\\chandigarh\\kanda\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac8c9d44"]])

export default __exports__